<template>
    <div class="login">
        <el-dialog :visible.sync="$store.state.login.displayLogin" width="473px" :before-close="handleClose">
            <div class="container" ref="container" v-if="!calogin">
                <div class="form-section">
                    <h2 class="welcome">欢迎登录</h2>
                    <div class="tabs tc">
                        <span class="tab" :class="{ 'active-tab': !activeForm }" @click="toggle">密码登录</span>
                        <i class="gap">|</i>
                        <span class="tab" :class="{ 'active-tab': activeForm }" @click="toggle">验证码登录</span>
                    </div>
                    <el-form v-if="!activeForm" key="pwdForm" :rules="pwdFormRule" :model="pwdForm" status-icon
                        ref="pwdForm" label-width="80px" class="login-form" @submit.native.prevent hide-required-asterisk>
                        <el-form-item label="用户名：" prop="username">
                            <el-input type="text" v-model="pwdForm.username" maxlength="11" autocomplete="off"
                                placeholder="请输入手机号码或用户名" id="userName"></el-input>
                        </el-form-item>
                        <el-form-item label="密码：" prop="password">
                            <el-input type="password" id="pwd" v-model="pwdForm.password" autocomplete="off"
                                placeholder="请输入登录密码" show-password>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="验证码：" prop="verifyCode" class="el-form-code-item">
                            <el-input v-model="pwdForm.verifyCode" id="verifycode" placeholder="请输入验证码"></el-input>
                            <div class="validate-code csp" @click="getCpatcha()">
                                <img :src="captcha" alt="" class="captcha">
                                <!-- <Identify :identifyCode="identifyCode"></Identify> -->
                            </div>
                        </el-form-item>
                        <el-form-item class="btn-box" label-width="0">
                            <el-button type="primary" id="submit" @click="submitForm('pwdForm')" class="login-btn">
                                {{ loginText }}
                            </el-button>
                            <span class="calogin" @click="showcaLogin">北京统一认证系统</span>
                        </el-form-item>
                    </el-form>
                    <el-form v-else key="verifyForm" :rules="verifyFormRule" :model="verifyForm" status-icon
                        ref="verifyForm" label-width="70px" class="login-form" @submit.native.prevent
                        hide-required-asterisk>
                        <el-form-item label="手机号：" prop="phone">
                            <el-input type="text" v-model="verifyForm.phone" maxlength="11" autocomplete="off" id="phone"
                                placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码：" prop="verifyCode" class="el-form-code-item">
                            <el-input v-model="verifyForm.verifyCode" id="tel-phone" placeholder="请输入手机验证码">
                            </el-input>
                            <el-button class="getVerfiyCode" @click="getCode" v-if="showCode">获取验证码</el-button>
                            <el-button class="getVerfiyCode" @click="getCode" v-else>{{ `重新发送(${count}s)` }}</el-button>
                        </el-form-item>

                        <el-form-item class="btn-box" label-width="0">
                            <el-button type="primary" id="tel-phone" @click="submitForm('verifyForm')" class="login-btn">
                                {{ loginText }}
                            </el-button>
                            <span class="calogin" @click="showcaLogin">北京统一认证系统</span>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="container-calogin" v-else>
                <div class="ca-title flex-align-between">
                    <span>教育ID登录/账号登录</span>
                    <span @click="handleClose">关闭</span>
                </div>
                <div class="ca-box">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                        <el-form-item prop="caUserId">
                            <el-input v-model="ruleForm.caUserId" prefix-icon="el-icon-user"
                                placeholder="请输入教育ID/账号"></el-input>
                        </el-form-item>
                        <el-form-item prop="caPassWord">
                            <el-input v-model="ruleForm.caPassWord" prefix-icon="el-icon-lock" placeholder="请输入教育ID密码/账号密码"
                                show-password :type="inputType"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-checkbox v-model="ruleForm.remember" label="记住密码"></el-checkbox>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" round @click="CALogin">登录</el-button>
                    <div class="password-box flex-align-between">
                        <span @click="fandId">找回教育ID</span>
                        <span @click="resetId">重置教育ID密码</span>
                        <span @click="respassword">重置密码</span>
                    </div>
                    <div class="phone-box flex-align">
                        <div class="phone-wrap flex-column">
                            <div class="phone flex-align">
                                <span>咨询电话:</span>
                                <span>4008310001,(010)56705700</span>
                            </div>
                            <div class="phone flex-align">
                                <span>咨询时间:</span>
                                <span>9:00-17:00</span>
                            </div>
                        </div>
                    </div>
                    <div class="other-login flex-column-center">
                        <span>第三方登录</span>
                        <img src="../../../assets/other-login.png" alt="" @click="otherLogin">
                    </div>
                </div>

            </div>
        </el-dialog>
        <!-- 多账号选择真实姓名弹窗 -->
        <el-dialog :visible.sync="choiceRealNameVisible" width="657px" class="dialog-realName-wrapper"
            :close-on-click-modal="false">
            <div class="dialog-realName">
                <p class="realName-tips">请选择您要使用账号人的真实姓名：</p>
                <ul class="realName-ul">
                    <li class="realName-li" :class="{ 'selected': selectedRealName.id == item.id }"
                        v-for="item in realNameList" :key="item.id" @click="selectedRealName = item">
                        <img class="realName-li-avatar" :src="downloadURL + item.avatar" alt=""
                            :onerror="$store.state.user.defaultAvatar">
                        <i class="el-icon-success" v-show="selectedRealName.id == item.id"></i>
                        <p class="realName-li-name">{{ item.name }}</p>
                    </li>
                </ul>
                <el-button class="realName-btn" @click="commitRealName">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SIdentify from "./component/identify";
import {encrypt} from "@/jsencrypt";
import axios from 'axios'
import Api from "../../../config/api";
export default {
    name: "login",
    components: {
        SIdentify,
    },
    props: ['schoolId', 'schoolName', 'logoType'],
    data() {
        // 验证手机号格式
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            } else if (!/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(
                value)) {
                return callback(new Error('手机号格式错误'));
            } else {
                return callback();
            }
        };
        // 验证 手机验证码
        var checkCode = (rule, value, callback) => {
            // console.log(value)
            if (!value) {
                return callback(new Error('验证码不能为空'));
            } else {
                let params = {
                    phone: this.verifyForm.phone,
                    code: String(value)
                }
                Api.Login.checkCode(params).then((resData) => {
                    //  console.log(resData)
                    if (resData.data.result) {
                        return callback();
                    } else {
                        this.$message({
                            message: resData.data.msg,
                            type: 'error'
                        });
                        return callback(new Error('验证码错误'));
                    }
                })
            }
        };
        // 验证用户名
        var checkUserName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('账号不能为空'));
            } else {
                return callback();
            }
        };
        // 验证密码
        var checkPwd = (rule, value, callback) => {
            // console.log(value)
            if (!value) {
                return callback(new Error('密码不能为空'));
            } else {
                return callback();
            }
        };
        // 验证 密码登录 验证码
        var checkVerifyCode = (rule, value, callback) => {
            if (window.location.host !== 'yun.cnuen.net') {
                return callback();
            }

            /**请勿删除 需要 验证码验证时 使用以下代码 */
            if (!value) {
                return callback(new Error('验证码不能为空'));
            } else if (value != this.identifyCode) {
                return callback(new Error('验证码错误'));
            } else {
                return callback();
            }
        };

        return {
            dialogVisible: false,
            activeForm: false, //当前表单 [false 用户名密码表单 / true 手机验证码表单]
            identifyCode: "",
            identifyRange: "1234567890", //验证码选取范围
            loginText: '登录', //登录文字
            loginFlag: true, //登录状态
            pwdForm: { //账号密码登录表单项
                password: "",
                username: "",
                verifyCode: "",
                type: []
            },
            pwdFormRule: { //账号密码登录 验证规则
                username: [{
                    required: true,
                    trigger: "blur",
                    validator: checkUserName
                }],
                password: [{
                    required: true,
                    trigger: "blur",
                    validator: checkPwd
                }],
                verifyCode: [{
                    required: false,
                    trigger: "blur",
                    validator: checkVerifyCode
                }],
            },
            showCode: true, //验证码按钮显隐状态
            count: 0, //倒计时 - 计数器
            timer: "", //倒计时 - 计时器
            dialogVisible: false, //弹窗状态
            pageToken: "",
            userinfoData: "",
            captcha: '', //用户名登录图形验证码
            choiceRealNameVisible: false, //选择真实姓名弹窗状态
            realNameList: [],
            selectedRealName: {},
            vphone: '',
            inputType: 'password',
            calogin: false,
            ruleForm: {
                caUserId: '',
                caPassWord: '',
                remember: false
            },
            rules: {
                caUserId: [
                    { required: true, message: '教育ID/账号不能为空', trigger: 'blur' },
                ],
                caPassWord: [
                    { required: true, message: '教育ID/账号密码不能为空', trigger: 'blur' },
                ],
            },
            verifyForm: { //手机号登录表单项
                phone: "",
                verifyCode: "",
            },
            verifyFormRule: { //手机号登录 验证规则
                phone: [{
                    required: true,
                    trigger: "blur",
                    validator: checkPhone
                }],
                verifyCode: [{
                    required: true,
                    message: "请输入验证码",
                    trigger: "blur",
                    validator: checkCode
                }],
            },
            showCode: true, //验证码按钮显隐状态
            count: 0, //倒计时 - 计数器
            timer: "", //倒计时 - 计时器
        };
    },
    methods: {
        handleClose() {
            this.$store.commit('isDisplayLogin', false);
            this.getCpatcha();
            this.calogin = false;
            this.$emit('hideLogin')
        },
        // 切换登录方式
        toggle() {
            this.activeForm = !this.activeForm;
            this.activeForm ? this.resetForm('pwdForm') : this.resetForm('verifyForm')
        },
        // 刷新用户密码登录验证码
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyRange, 4);
        },
        // 数字验证码获取
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyRange[Math.floor(Math.random() * (this.identifyRange.length - 0) +
                    0)];
            }
        },
        // 获取验证码
        async getCode() {
            if (!/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(this
                .verifyForm
                .phone)) {
                this.$message({
                    message: '手机号格式错误',
                    type: 'error'
                });
                return
            }
            this.countDown();
            let params = {
                phone: this.verifyForm.phone
            }
            let resData = await Api.Login.getVerifyCode(params)
            // console.log(resData);
            if (resData.code === 200 && resData.msg === "请求成功") {
                this.$message({
                    message: '验证码发送成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: resData.msg,
                    type: 'error'
                });
            }
        },
        // 倒计时
        countDown() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.showCode = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.showCode = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }
        },
        // 点击验证表单
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.commitForm(formName);
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 表单提交
        async commitForm(formName) {
            const loading = this.$loading(this.$store.state.user.loadingConfig);
            console.log('加密密码:',encrypt(this[formName].password))
            // 判断是否是虚拟账号
            let data = {
                username: this[formName].username,
                password: this[formName].password,
            };
            let vresData = await Api.Login.isVirtua(data);
            if (vresData.data) {
                console.log('是虚拟账号')
                loading.close();
                let params = {
                    username: this[formName].username,
                    password: encrypt(this[formName].password),
                    keyCode: this.keyCode,
                    captchaCode: this[formName].verifyCode
                };
                let vloginresData = await Api.Login.vpclogin(params);
                console.log("虚拟账号登录:", vloginresData);
                if (!vloginresData.data.bind) {
                    console.log('虚拟账号是第一次登录--->需完善信息');
                    this.$store.commit('isDisplayLogin', false);
                    // 虚拟账号是第一次登录--->需完善信息
                    this.$router.push({
                        path: '/updateUserInfo',
                        query: {
                            tempToken: vloginresData.data.temp_token,
                            logoType: this.logoType
                        }
                    })
                } else {
                    console.log('虚拟账号不是第一次登录--->提示用手机号登录')
                    // 虚拟账号不是第一次登录--->提示用手机号登录
                    this.vphone = vloginresData.data.phone;
                    this.$confirm(`请用手机号${this.vphone}登录`, '提示', {
                        showCancelButton: false,
                        showConfirmButton: true,
                        type: 'warning'
                    }).then(() => {
                        this.getCpatcha()
                    })
                }
            } else {
                console.log('不是虚拟账号')
                let params = {};
                let resData = '';
                // 用户名、密码登录
                if (formName === 'pwdForm') {
                    params = {
                        username: this[formName].username,
                        password: encrypt(this[formName].password),
                        keyCode: this.keyCode,
                        captchaCode: this[formName].verifyCode
                    };
                    resData = await Api.Login.login(params);
                }
                //手机验证码登录 
                if (formName === 'verifyForm') {
                    params = {
                        phone: this[formName].phone,
                        code: this[formName].verifyCode
                    }
                    resData = await Api.Login.loginByPhone(params);
                }
                console.log('登录resData:', resData)
                this.$store.commit('isDisplayLogin', false);
                this.getCpatcha()
                if (resData.code === 200 && resData.data.access_token) {
                    loading.close();
                    sessionStorage.setItem('token', resData.data.access_token);
                    sessionStorage.setItem('member', resData.data.member);
                    this.getFileToken();
                    // 多用户判断
                    if (!resData.data.member || resData.data.member == 1) { // 账户身上只有一个用户 || 账户身上不存在用户 =>直接登录
                        if (this.logoType == '智慧研修') {
                            this.$emit('getUserinfo');
                            window.open(`https://jm.cnuen.net/login?origin=cnueb&access_token=${resData.data.access_token}&member=${resData.data.member}`) // 正式
                            // window.open(`https://localhost:8081/login?origin=cnueb&access_token=${resData.data.access_token}&member=${resData.data.member}`) // 测试
                            return
                        }else if(this.logoType == '协作管理空间'){
                            this.$emit('getUserinfo');
                            window.open("https://dctest.lezhireading.com/#/country")
                            // window.open(`http://localhost:8081/#/leader_data?projectId=234&projectName=classin正式&token=${resData.data.access_token}&roleId=124`)
                            // window.open(`https://dctest.lezhireading.com/#/leader_data?projectId=234&projectName=classin正式&token=${resData.data.access_token}&roleId=124`)
                        }else {
                            this.getUserinfo();
                        }
                    } else { // 账户身上有多个用户 => 选择要登录的用户
                        this.choiceRealNameVisible = true;
                        this.getRealNameList();
                    }
                    this.$set(this.pwdForm, 'verifyCode', '');
                } else {
                    loading.close();
                    this.$message.error({
                        message: resData.data.msg,
                    });
                }
            }

        },
        // 获取文件预览token 
        async getFileToken() {
            let resData = await Api.Login.getFileToken();
            console.log('获取文件预览token', resData.data.token);
            sessionStorage.setItem('fileToken', resData.data.token);
        },
        // 获取多账户列表
        async getRealNameList() {
            let resData = await Api.Login.getRealNameList();
            this.realNameList = resData.data.members
        },
        // 选择多账号
        async commitRealName() {
            let params = {
                memberId: this.selectedRealName.id
            }
            let resData = await Api.Login.getMemberToken(params);
            console.log('选择多账号', resData);
            if (resData.code === 200 && resData.data.access_token) {
                sessionStorage.setItem('token', resData.data.access_token);
                sessionStorage.setItem('member', resData.data.member);
                this.choiceRealNameVisible = false;
                this.$emit('getUserinfo');
                if (this.logoType == '智慧研修') {
                    window.open(`https://jm.cnuen.net/login?origin=cnueb&access_token=${resData.data.access_token}&member=${resData.data.member}`)
                    return
                } else {
                    this.getUserinfo();
                }
            } else {
                this.$message.error(resData.data.msg);
            }

        },
        // 获取用户信息
        async getUserinfo() {
            let resData = await Api.Login.userInfo();
            console.log('用户信息', resData);
            if (JSON.stringify(resData.data) == '{}') {
                this.$message({
                    message: '获取个人信息失败，请联系管理员',
                    type: 'error'
                });
                sessionStorage.clear();
                return;
            };
            console.log('logoType:',this.logoType)
            if (this.logoType == '空中课堂') {
                // 请求code
                this.getUrlCode(resData.data.phone, resData.data.id)
            } else if (this.logoType == 'banner') {
                this.$emit('getUserinfo');
                let routeData = this.$router.resolve({ path: '/handbook' });
                window.open(routeData.href, '_blank');
            } else {
                console.log('没有logoType')
                this.$emit('getUserinfo');
            }


        },
        // 获取跳转空中课堂code
        async getUrlCode(phone, userId) {
            let data = {
                phone,
                userId,
                projectId: 280,
                userRole: 100
            }
            let resData = await Api.Login.getCode(data);
            console.log('获取跳转空中课堂code:', resData);
            if (resData.code == 200) {
                this.$emit('getUserinfo');
                window.open(`https://basic.beijing.smartedu.cn/autologin?code=${resData.data}`);
            } else {
                this.$message({
                    message: '获取code失败,请联系管理员',
                    type: 'error'
                });
            }
        },
        // 按回车登录
        enterLogin() {
            let key = window.event.keyCode
            if (window.event === undefined) {
                key = e.keyCode
            } else {
                key = window.event.keyCode
            }
            if (key === 13 && !this.activeForm) {
                this.submitForm('pwdForm')
            } else if (key === 13 && this.activeForm) {
                this.submitForm('verifyForm');
            } else {
                return;
            }
        },
        //重置输入框中的数据
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 获取图片验证码 
        async getCpatcha() {
            this.$set(this.pwdForm, 'verifyCode', '');
            let resData = await Api.Login.getCpatcha();
            // console.log(resData);
            if (!resData || JSON.stringify(resData.data) == '{}') return;
            this.captcha = resData.data.image;
            this.keyCode = resData.data.keyCode;
        },
        async showcaLogin() {
            // this.calogin = true
            let  resData = await Api.Login.getCaUrl()
            console.log('获取CA跳转地址:',resData);
            window.location.href = resData.data
        },
        fandId() {
            window.open("http://yhzx.bjedu.cn/usercenter/portalManage/resetUserNameAction1.action")
        },
        resetId() {
            window.open("http://yhzx.bjedu.cn/usercenter/userInfo/initRestPwd.action")
        },
        respassword() {
            window.open("http://yhzx.bjedu.cn/usercenter/portalManage/resetPwdAction1.action")
        },
        otherLogin() {
            window.open("https://auth.smartedu.cn/uias/login")
        },
        async CALogin() {
            let data = {
                account: this.ruleForm.caUserId,
                password: this.ruleForm.caPassWord,
            }
            let resData = await Api.Login.calogin(data);
            console.log('CA登录结果:', resData);
            this.$store.commit('isDisplayLogin', false);
            if (resData.code === 200 && resData.data.access_token) {
                sessionStorage.setItem('token', resData.data.access_token);
                this.getUserinfo();
            } else if (!resData.data.bind) {
                this.$router.push({
                    path: "/upDateInfo",
                    query: {
                        userName: resData.data.user_name,
                        tempToken: resData.data.temp_token
                    }
                })
            }
        }

    },

    created() { },
    mounted() {
        this.identifyCode = "";
        this.makeCode(this.identifyRange, 4);
        window.addEventListener('keyup', this.enterLogin, true);
        this.getCpatcha()
    },
    destroyed() {
        this.activeForm = false;
        window.removeEventListener('keyup', this.enterLogin, true);
    },
}
</script>

<style lang="less" scoped>
@import "./login.less";
</style>